module.exports = __webpack_public_path__ + "media/images/ui/arrow-up-791afb9bd7430d38530269b9cde49fc8.png";